<script lang="tsx">
import { computed, defineComponent } from 'vue'
import { createNamespace } from '@bd/vue3-utils'
import { Table } from 'ant-design-vue'
import { useTableRequest, usePagination } from './useTableRequest'
import { initSelect } from './useSelect'
import Current from './Current.vue'
import { tableSelectProps } from './props'
const [name, bem] = createNamespace('TableSelect')

export default defineComponent({
  name,
  props: tableSelectProps,
  emits: ['update:value', 'change'],
  setup(props, { emit, attrs, slots, expose }) {
    const { pagination } = usePagination(props.pagination) // 使用分页逻辑
    const { handleSelect, handleRemove, setDataSourceMap, rowSelection } = initSelect(props, emit)
    const { state } = useTableRequest({
      api: props.api!,
      params: props.params,
      immediate: props.immediate,
      pagination,
      useLastId: props.useLastId,
      afterLoad(data) {
        const _data = props.pagination === false ? data : data.data
        setDataSourceMap(_data)
        return props?.afterLoad?.(data) ?? data
      }
    })
    const rowSelectionMerged = computed(() => Object.assign(rowSelection, props.rowSelection))
    const customRow = record => {
      return {
        onClick() {
          const isDisabled = rowSelectionMerged.value?.getCheckboxProps?.(record)?.disabled
          if (!isDisabled) {
            handleSelect(record[props.valueKey])
          }
        }
      }
    }
    const handleClose = record => {
      const _key = record[props.valueKey]
      handleRemove(_key)
    }
    const footer = () => {
      if (props.current === false) return null
      return <Current nameKey={props.currentKey} onClose={handleClose} v-slots={{ current: slots?.current }} />
    }
    expose({
      state
    })
    return () => (
      <Table
        size='middle'
        class={bem({ hideno: props.useLastId })}
        scroll={{ y: props.height }}
        rowKey={props.valueKey}
        rowSelection={rowSelectionMerged.value}
        columns={props.columns}
        pagination={props.pagination === false ? false : pagination.value}
        loading={state.loading}
        dataSource={state.dataSource}
        custom-row={customRow}
        v-slots={{
          footer
        }}
        {...attrs}
      />
    )
  }
})
</script>
<style lang="less">
.table-select {
  .ant-table-container {
    border: 1px solid transparent;
  }

  .ant-table-footer {
    padding: @padding-sm 0 0;
    background: transparent;
  }

  &--hideno {
    .ant-pagination-item {
      display: none;
    }
  }
}

.ant-form-item-has-error {
  .ant-table-container {
    border: 1px solid @error-color;
  }
}
</style>
